import { forwardRef, useEffect, useState } from "react";
import Radio from "@mui/material/Radio";
import styles from "./MainQuestion.module.css";
import { Button } from "@mui/material";
import ShortcutIcon from "@mui/icons-material/Shortcut";
import { translate } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import ListofUsers from "./ListOfUsers";
import Tooltip from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { cancelForwrdedQuetion } from "../../redux/actions/fowardQuestionActionCreators";
import { useParams } from "react-router-dom";
import CancelModal from "./CancelForwardModal";

const MainQuestion = forwardRef(
  (
    {
      is_completed,
      question,
      currentQuestion,
      handleQuestion,
      questionsCount,
      myAnswer,
      questionIndex,
      handleForwarded,
      forwarded,
      removeAnswer,
      allUsers,
      forwardedUseCaseQuestions,
      setForwardedUseCaseQuestions,
      currentUseCase,
      setForwardedUseCase,
      forwardedUseCase,
      setProgression,
      progression,
      forwardId,
      isAllowed,
    },
    ref,
    quizDisabled
  ) => {
    const nextQuestionHandler = (id, questionIndex, weight) => {
      handleQuestion(question, id, questionIndex, weight);
    };
    const { isAuth } = useSelector((state) => state.user);
    const [open, setOpen] = useState(false);
    const [idQuestion, setIdQuestion] = useState("");
    const [title, setTitle] = useState("");
    const [idUseCase, setIdUseCase] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [titleFr, setTitleFr] = useState("");
    const [disabledUseCase, setDisabledUseCase] = useState(true);
    const [userResponder, setUserResponder] = useState("");
    const [disableCancel, setDisableCancel] = useState(true);
    const { t } = useTranslation();
    const isMobile = useMediaQuery("(max-width:900px)");
    const params = useParams();

    const dispatch = useDispatch();

    const orgaId = localStorage.getItem("orgaId");
    const storedUser = localStorage.getItem("user");
    const accountType = JSON.parse(storedUser)?.account_type;
    const role = JSON.parse(storedUser)?.role;


    const cancelForward = () => {
      dispatch(
        cancelForwrdedQuetion(
          forwardId,
          currentUseCase?.id,
          params.quizId,
          orgaId,
          accountType
        )
      );
      setOpenModal(false);
    };

    const identifier = params.quizId;
    const removeUser = (id) => {
      if (
        forwardedUseCase.some(
          (el) => el.usecase_id === currentUseCase?.id && !el.answered
        )
      ) {
        setOpenModal(true);
      } else {
        handleForwarded(
          forwarded.filter((el) => el.usecase_id !== currentUseCase?.id)
        );
        setForwardedUseCaseQuestions(
          forwardedUseCaseQuestions.filter(
            (el) => !currentUseCase.questions.includes(el)
          )
        );
        setForwardedUseCase(
          forwardedUseCase.filter((el) => el.usecase_id !== currentUseCase?.id)
        );
        setDisabledUseCase(false);
      }
    };

    // useEffect(() => {
    //   if (forwardedUseCaseQuestions.some((el) => el.id === question?.id)) {
    //     setDisabledUseCase(true)
    //   } else {
    //     setDisabledUseCase(false)
    //   }
    // }, [forwardedUseCaseQuestions])
    const getUserFullName = (user) => {
      return `${user?.first_name} ${user?.last_name}`;
    };

    useEffect(() => {
      if (
        forwarded.some((el) => el.usecase_id === currentUseCase?.id) ||
        forwardedUseCase.some(
          (el) => el.usecase_id === currentUseCase?.id && !el.answered
        )
      ) {
        setDisabledUseCase(true);
      } else {
        setDisabledUseCase(false);
      }
      if (
        forwardedUseCase.some(
          (el) => el.usecase_id === currentUseCase?.id && !el.answered
        )
      ) {
        setDisableCancel(true);
      } else {
        setDisableCancel(false);
      }
    }, [forwarded, forwardedUseCase]);

    useEffect(() => {
      let theUseCase = forwardedUseCase?.find(
        (el) => el.usecase_id === currentUseCase?.id
      );
      if (theUseCase?.answered) {
        setUserResponder(
          getUserFullName(
            allUsers?.find((u) => u?.email === theUseCase?.forwarded_to)
          )
        );
      }
    }, [forwarded, forwardedUseCase, allUsers]);

    const handleForwardQuestion = () => {
      setOpen(true);
      setIdUseCase(currentUseCase?.id);
      setIdQuestion(question?.id);
      setTitle(question?.title);
      setTitleFr(question?.title_fr);
    };

    const handleCloseModal = () => {
      setOpenModal(false);
    };
    const handleClose = () => {
      setOpen(false);
    };
    return (
      <div className={styles.container} ref={ref}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className={styles.question_number} style={{ fontSize: "27px" }}>
            QUESTION {questionIndex + 1}
          </span>
          {isAuth && !is_completed && isAllowed && role !=="enterprise_user" && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* {forwarded.some((el) => el.idQuestion === question?.id) && ( */}
              {disabledUseCase && (
                <Button
                  // disabled={disableCancel}
                  color="error"
                  onClick={() => removeUser(currentUseCase)}
                >
                  {t("cancel")}
                </Button>
              )}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Button
                  color="secondary"
                  startIcon={!isMobile && <ShortcutIcon />}
                  style={{
                    borderRadius: "24px",
                    height: isMobile ? "30px" : "40px",
                    fontSize: isMobile && "10px",
                  }}
                  variant="outlined"
                  size="small"
                  disabled={disabledUseCase}
                  onClick={handleForwardQuestion}
                >
                  {forwardedUseCase.some(
                    (el) => el.usecase_id === currentUseCase?.id && !el.answered
                  )
                    ? forwardedUseCase?.some(
                        (el) => el.usecase_id === currentUseCase?.id
                      )
                      ? getUserFullName(
                          allUsers?.find(
                            (u) =>
                              u?.email ===
                              forwardedUseCase?.find(
                                (el) => el?.usecase_id === currentUseCase?.id
                              )?.forwarded_to
                          )
                        )
                      : t("forward_to_a_friend")
                    : forwarded?.some(
                        (el) => el.usecase_id === currentUseCase?.id
                      )
                    ? forwarded.find(
                        (el) => el.usecase_id === currentUseCase?.id
                      )?.fullName
                    : t("forward_to_a_friend")}
                </Button>
                {userResponder !== "" && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    {t("answred")}{" "}
                    {userResponder !== "undefined undefined"
                      ? userResponder
                      : t("user_deleted")}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
        <h4 style={{ padding: "20px 0px" }}>
          {question?.[translate("title")] || t("not_specified")}{" "}
        </h4>
        {question?.choices?.map((option) => (
          <p
            key={option.id}
            className={`${
              !is_completed && isAllowed
                ? disabledUseCase
                  ? styles.forwarded
                  : styles.options
                : styles.display_mode
            }
         ${
           myAnswer?.choice === option.id && !disabledUseCase
             ? styles.selected
             : null
         }
         `}
            onClick={(e) => {
              !is_completed && isAllowed && !disabledUseCase
                ? nextQuestionHandler(option.id, questionIndex, option.weight)
                : console.log(e);
            }}
          >
            <Radio
              disabled={
                is_completed || quizDisabled || disabledUseCase || !isAllowed
              }
              checked={!disabledUseCase && myAnswer?.choice === option.id}
              checkedIcon={
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                    fill="white"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 12L11 14L15 10"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
            />
            {option[translate("title")] || t("not_specified")}
          </p>
        ))}
        {questionIndex !== questionsCount - 1 && (
          <>
            <br />
            <hr></hr>
          </>
        )}
        {isAuth && (
          <ListofUsers
            open={open}
            handleClose={handleClose}
            handleForwarded={handleForwarded}
            forwarded={forwarded}
            idQuestion={idQuestion}
            title={title}
            titleFr={titleFr}
            removeAnswer={removeAnswer}
            allUsers={allUsers}
            currentUseCase={currentUseCase}
            idUseCase={idUseCase}
            setProgression={setProgression}
            progression={progression}
          />
        )}
        <CancelModal
          open={openModal}
          handleClose={handleCloseModal}
          cancelForward={cancelForward}
        />
      </div>
    );
  }
);

export default MainQuestion;
